import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { PaginationFooter } from 'ui/paginationFooter';
import { TableHeader } from 'ui/tableHeader';
import { body2, colors, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

const customSpacing = {
  p14: pxToRem(14),
};

export const TableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const StyledTableHeader = styled(TableHeader)`
  & [role='columnheader'] {
    padding: ${customSpacing.p14};
  }
`;

export const Cell = styled.div`
  ${body2};
  box-sizing: border-box;
  display: table-cell;
  overflow-y: visible;
  padding: ${spacing.threeQuarter} ${spacing.base};
  margin: 0;
`;

export const CellRight = styled(Cell)`
  text-align: right;
`;

export const LinkText = styled(Link)`
  ${body2};
  text-decoration: underline;
  color: ${colors.link};
`;

export const StyledPaginationFooter = styled(PaginationFooter)`
  padding: ${spacing.base} ${spacing.double};
`;
